import { Injectable } from '@angular/core';
import { CanActivate, CanLoad } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AuthStateService } from '../app/auth/auth-state.service';

@Injectable({
    providedIn: 'root',
})
export class NoShowGuard implements CanLoad, CanActivate {

    constructor(
        private navController: NavController,
        private authStateService: AuthStateService
    ) {}

    /**
     * Runs when lazy-loaded module is first loaded.
     */
    canLoad(): boolean {
        return this.checkShows();
    }

    /**
     * Runs on EVERY navigation to protected routes.
     * This is needed because canLoad only runs once per module load.
     */
    canActivate(): boolean {
        return this.checkShows();
    }

    private checkShows(): boolean {
        const user = this.authStateService.user();

        if (!user) {
            // No user - allow navigation, AuthGuard will handle redirect
            return true;
        }

        const hasShows = user.shows && user.shows.length > 0;

        if (!hasShows) {
            this.navController.navigateRoot('/no-show');
            return false;
        }

        return true;
    }
}
